import Hero from "./components/Hero";
import About from "./components/About";
import Partners from "./components/Partners";
import Features from "./components/Features";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Videos from './components/Videos';

import "./App.css"; 

function App() {
  return (
    <div className="min-h-screen bg-surface-light dark:bg-surface-dark transition-colors duration-300">
      <Navbar />
      <main className="pt-20"> {/* Navbar yüksekliği için padding */}
        <Hero />
        <About />
        <Features />
        <Videos />
        <Partners />
      </main>
      <Footer />
    </div>
  );
}

export default App;